// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stars .show2[data-v-f2e25236]:after,.stars .show[data-v-f2e25236]:after{content:\"★\"}.show2[data-v-f2e25236]{color:#f7ba2a}", ""]);
// Exports
module.exports = exports;
